// Georeverse utilities to get city and address from coordinates
export async function getReverseGeocodeCity(latitude: number, longitude: number): Promise<string | null> {
  try {
    // Using OpenStreetMap Nominatim free API
    const response = await fetch(
      `https://nominatim.openstreetmap.org/reverse?format=json&lat=${latitude}&lon=${longitude}`,
      {
        headers: {
          'User-Agent': 'MiniBid-App'
        }
      }
    );
    
    if (!response.ok) return null;
    
    const data = await response.json();
    
    // Try to get city, town, or village in order of preference
    const address = data.address || {};
    return (
      address.city ||
      address.town ||
      address.village ||
      address.municipality ||
      address.county ||
      null
    );
  } catch (error) {
    console.error('[getReverseGeocodeCity] Error:', error);
    return null;
  }
}

export function getCityFromLocationDisplayName(displayName: string): string {
  // If displayName is already a city name, return it
  // Sometimes locations come as "City, Street" or similar
  if (!displayName) return '';
  
  const parts = displayName.split(',');
  // Return the first part (usually the city)
  return parts[0].trim();
}
